/**
 * Mock ReMa resource instances (endpoint: getResourceInstances).
 * Used while ReMa isn't live in an environment (mock: true in apiRoutes.yml).
 * Reuses the event form's seed workloads so publisher names resolve.
 */
import { EVENT_WORKLOAD_INSTANCES } from '@/forms/events/eventConstants'

export const MOCK_GET_RESOURCE_INSTANCES = {
  content: { resourceInstances: EVENT_WORKLOAD_INSTANCES },
}
